// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: 'Alle',
  AllDocuments: 'Alle Dokumente',
  Any: 'Irgendwelche',
  Today: 'Heute',
  Yesterday: 'Gestern',
  LastWeek: 'Letzte Woche',
  LastMonth: 'Letzten Monat',
  DateFrom: 'Von',
  DateTo: 'Zu',
  DateRange: 'Datumsbereich',
  NeverViewed: 'Nicht angesehen oder geändert seit dem letzten Aufruf',
  AddedLastLogin: 'Seit der letzten Anmeldung hinzugefügt oder geändert',
  GlobalNetworkErrorMessage:
    'Es liegt ein Problem mit dem Netzwerk vor. Versuchen Sie es erneut oder wenden Sie sich an den Support.',
  GlobalIntermediateProxyErrorMessage:
    'Ihr Netzwerk hat diese Anfrage an den Datenraum abgefangen. Wenden Sie sich an Ihre IT-Abteilung.',
  GlobalUnexpectedErrorWithIdMessage:
    'Es liegt ein Problem mit Ihrem Datenraum vor. Geben Sie diesen Code \u003c[ErrorId]\u003ean unseren Kundenservice an.',
  GlobalUnexpectedErrorMessage:
    'Es liegt ein Problem mit Ihrem Datenraum vor. Bitte wenden Sie sich an unseren Kundenservice.',
  NoRecordsFound: 'Keine Aufzeichnungen gefunden.',
  Save: 'Speichern',
  Print: 'Drucken',
  ViewAs: 'Anzeigen als',
  Documents: 'Dokumente',
  Date: 'Datum',
  HideEmptyFolders: 'Leere Ordner ausblenden',
  Search: 'Suche',
  Actions: 'Aktionen',
  Filter: 'Filtern',
  Self: 'Sie',
  Allowed: 'Ermöglicht',
  Denied: 'Verweigert',
  PleaseEnterValidToDate: 'Bitte geben Sie ein gültiges Bis-Datum ein.',
  PleaseEnterValidFromDate: 'Bitte geben Sie ein Gültigkeitsdatum ein.',
  SavingAllowed: 'Speichern erlaubt',
  SavingDenied: 'Speichern verweigert',
  PrintingAllowed: 'Drucken erlaubt',
  PrintingDenied: 'Drucken verweigert',
  ChooseLanguage: 'Sprache wählen',
  EditProfile: 'Profil bearbeiten',
  DataRooms: 'Datenräume',
  Administration: 'Verwaltung',
  MyAccount: 'Mein Konto',
  Profile: 'Profil',
  Logout: 'Abmelden',
  Loading: 'Laden',
  Success: 'Erfolg',
  Disabled: 'Deaktiviert',
  Ok: 'Ok',
  And: 'und',
  Demo: 'Demo',
  TenderSubmissionsStart: 'Einreichungsprozess starten',
  TenderSubmissionsOverdue:
    'Der Einreichungsprozess ist beendet. Dokumente, die Sie jetzt hochladen, werden als verspätet markiert.',
  TenderSubmissionsClose: 'Der Einreichungsprozess ist beendet.',
  Later: 'Später',
  StartNow: 'Beginnen Sie jetzt',
  StartSubmissionDialogTitle: 'Einreichungsprozess starten',
  StartSubmissionDialogContent:
    'Bietern werden benachrichtigt, dass sie Dokumente hochladen und anzeigen können. ' +
    'Ihre internen Teams können während des Einreichungsprozess nicht auf Dokumente zugreifen.',
  StartSubmissionDialogCloseDateContent:
    'Der Übermittlungsprozess endet am ${closeDate}.',
  SubmissionInformationIsIncomplete:
    'Die Übermittlungsinformationen sind unvollständig. ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    'Bietern wurden nicht eingeladen oder entfernt. ',
  InviteBidderTeams: 'Bietern einladen',
  UpdateSecuritySettings: 'Sicherheitseinstellungen aktualisieren',
  UpdateTheirSecuritySettings:
    'Aktualisieren Sie ihre Sicherheitseinstellungen.',
  OnTimeSubmission: 'Pünktliche Einreichung',
  LateSubmission: 'Verspätete Einreichung',
  DeleteAllDocuments: 'Alle Einreichungsdokumente löschen',
  Manage: 'Verwalten',
  ManageSubmissions: 'Einreichungen verwalten',
  NotStarted: 'Nicht gestartet',
  Closed: 'Geschlossen',
  ExtraTime: 'In Verlängerung',
  Open: 'Öffnen',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    'Erstellen Sie die Struktur und legen Sie das Schlussdatum für Bieteeinreichungen fest.',
  AddSubmissionWindow: 'Übermittlungsfenster hinzufügen',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 Bietern hat keinen Zugriff, um Einreichungen hinzuzufügen.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    '${totalBidders}-Bieter haben keinen Zugriff, um Übermittlungen hinzuzufügen.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} von ${totalDocsCount}-Dokumenten',
  BulkRedactionMarksToRedact: '${selectedMarksCount}-Elemente zum Redigieren',
  BulkRedactionMarksRedacted: '${redactionMarksCount}-Elemente redigiert',
  BulkRedactionSkipAndNext: 'Dokument überspringen',
  BulkRedactionSkipAndFinish: 'Überspringen und die Redigierung abschließen',
  BulkRedactionSaveAndNext: 'Speichern und nächstes Dokument',
  BulkRedactionSaveAndFinish: 'Speichern und die Redigierung abschließen',
  BulkRedactionRedactAllRemainingDocuments:
    'Alle ${documentsRemaining}-Dokumente redigieren',
  BulkRedactionCancel: 'Stornieren',
};
